// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1zwBc","footer":"ModalError_footer__1rvqa"};